import { type AuthenticatedUser } from '@api/services/auth';

import { $userStore } from './store';

const setUserInitializing = (): void => {
  $userStore.set({
    status: 'initializing',
    user: null,
  });
};

const setUser = (user: AuthenticatedUser): void => {
  $userStore.set({
    status: 'authenticated',
    user,
  });
};

const clearUser = (): void => {
  $userStore.set({
    status: 'unauthenticated',
    user: null,
  });
};

const setUserError = (): void => {
  $userStore.set({
    status: 'error',
    user: null,
  });
};

export const userStoreActions = {
  setUserInitializing,
  setUser,
  clearUser,
  setUserError,
};
